export default __webpack_public_path__ + "d4c918b236fac9585963d4586f867b98.webp";